import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'

const CustomMenu = ({ children, ...props }) => {

    const {
        open,
        options,
        position,
        onClick = () => { }
    } = props

    return (
        <div className={`${open ? 'flex' : 'hidden'} rounded-xl shadow-[0px_0px_20px_#00000026] p-5 md:p-3 min-w-[267px] md:min-w-[200px] flex-col bg-white z-10 border-[#E7E7E7] absolute  ${position || 'top-8 left-0'}`}>
            {(options || []).map(e => (
                <Link
                    onClick={onClick}
                    aria-label={e?.label}
                    key={e?.href}
                    href={e?.href}
                    target={e?.target}
                    className="rounded-lg text-base text-[#35343A] text-left py-4 px-6 md:py-3 md:px-4 hover:bg-[#98AABE26] transition-all duration-300"
                >
                    {e?.label}
                </Link>
            ))}
        </div>
    )
}

CustomMenu.propTypes = {
    open: PropTypes.bool.isRequired,
    children: PropTypes.element,
    options: PropTypes.array,
    position: PropTypes.string,
}

export default CustomMenu